import * as React from 'react';
import { useMergedRef } from '@sravni/react-utils';
import { Textarea } from '../../Textarea/src/Textarea.js';

const InputView = React.forwardRef((props, ref) => {
    const { children, ...restProps } = props;
    if (children) {
        const child = React.Children.only(children);
        const inputProps = {
            ...restProps,
            ...child.props,
            // eslint-disable-next-line react-hooks/rules-of-hooks
            ref: useMergedRef(ref, child.ref),
        };
        return React.cloneElement(child, inputProps);
    }
    return React.createElement(Textarea, { ref: ref, ...restProps });
});

export { InputView };
//# sourceMappingURL=InputView.js.map
